import { Omit } from 'bold-ui'
import { DEFAULT_SELECT_SIZE, SelectField, SelectFieldProps } from 'components/form'
import { useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { ProcedimentoOdontoSelectFieldDocument } from 'graphql/hooks.generated'
import {
  ProcedimentoOdontoSelectFieldQuery,
  ProcedimentoOdontoSelectFieldQueryVariables,
  TipoParteBucalEnum,
} from 'graphql/types.generated'
import React from 'react'

import { ProcedimentoSelectFieldItem } from '../ProcedimentoSelectField/ProcedimentoSelectFieldItem'

export type ProcedimentoOdontoSelectModel = {
  id: string
  descricao: string
  codigo: string
  procedimentoReferencia?: { id: string; descricao: string; codigo: string }
}

export interface ProcedimentoOdontoSelectFieldProps
  extends Omit<SelectFieldProps<ProcedimentoOdontoSelectModel>, 'items' | 'itemToString'> {
  dataNascimento: LocalDate
  tipoParteBucal: TipoParteBucalEnum
  numeroDente?: number
}

export function ProcedimentoOdontoSelectField(props: ProcedimentoOdontoSelectFieldProps) {
  const { dataNascimento, tipoParteBucal, numeroDente, ...rest } = props

  const asyncProps = useAsyncQuerySelect<
    ProcedimentoOdontoSelectModel,
    ProcedimentoOdontoSelectFieldQuery,
    ProcedimentoOdontoSelectFieldQueryVariables
  >({
    query: ProcedimentoOdontoSelectFieldDocument,
    extractItems: (data) => data?.procedimentosEvolucaoOdonto.content,
    variables: (inputString) => ({
      input: {
        query: inputString,
        tipoParteBucal: tipoParteBucal,
        dataNascimento: dataNascimento,
        numeroDente: numeroDente,
        pageParams: {
          size: DEFAULT_SELECT_SIZE,
        },
      },
    }),
  })

  const itemToString = (item: ProcedimentoOdontoSelectModel) =>
    item?.procedimentoReferencia?.descricao || item?.descricao

  return (
    <SelectField<ProcedimentoOdontoSelectModel>
      itemToString={itemToString}
      renderItem={ProcedimentoSelectFieldItem}
      {...asyncProps}
      {...rest}
    />
  )
}
